<template>
  <v-dialog v-model="open" max-width="500px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <location-info-item
        icon="mdi-phone"
        icon-action="mdi-pencil-outline"
        title="Telefone"
        :subtitle="location.data ? location.data.primary_phone : formData.primary_phone"
        v-bind="attrs"
        v-on="on"
      />
    </template>

    <v-card>
      <v-toolbar elevation="0">
        <v-card-title class="ml-0 pl-1">
          Número de telefone
        </v-card-title>

        <v-spacer />

        <v-btn icon @click="open = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form ref="form" v-model="formValid" lazy-validation @submit="e => e.preventDefault()">
          <v-text-field
            v-mask="'(##) ####-####?#'"
            v-model="formData.primary_phone"
            :counter="15"
            :rules="phoneRules"
            outlined
            v-on:keyup.enter="() => callAction()"
          ></v-text-field>

          <v-alert
            v-if="alertScheduledTask"
            dense
            border="right"
            type="warning"
          >
            Existe um agendamento pendente para essa informação
          </v-alert>

          <schedule-form  v-if="!bulkUpdate" small v-on:change="changeScheduleDate" />
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="cancel">
          Cancelar
        </v-btn>
        <v-btn :loading="loading" color="primary" text @click="callAction">
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { get } from 'lodash';
import { TYPE_UPDATE_LOCATION_PHONE } from '@/constants/tasks';
import LocationInfoItem from '@/views/Locations/Components/LocationInfoItem';
import ScheduleForm from '@/views/Locations/Components/ScheduleForm';

export default {
  name: 'LocationPhoneModal',
  props: {
    action: Function,
    bulkUpdate: {
      type: Boolean
    },
    alertScheduleTask: Array,
  },
  components: {
    LocationInfoItem,
    ScheduleForm
  },
  methods: {
    cancel() {
      this.open = false
      this.resetData()
    },
    resetData() {
      const { primary_phone } = this.formDataOriginal
      this.formData.primary_phone = primary_phone
      if (this.bulkUpdate) {
        this.$emit('removePayload', 'primary_phone')
      }
    },
    callAction: async function() {
      if (!this.$refs.form.validate()) {
        return false
      }

      if (this.bulkUpdate) {
        this.$emit('savePayload', 'primary_phone', this.formData.primary_phone)
      } else if (this.action) {
        this.loading = true
        await this.action(this.formData)
        this.loading = false
      }

      this.open = false
    },
    changeScheduleDate: function(data) {
      this.formData.schedule_start = data.schedule_start
      this.formData.schedule_start_at = data.schedule_start_at
      this.formData.schedule_end = data.schedule_end
      this.formData.schedule_end_at = data.schedule_end_at
    }
  },
  computed: {
    ...mapState({
      location: (state) => state.locations.location
    })
  },
  mounted() {
    if(this.alertScheduleTask) {
      this.alertScheduleTask.map(type => {
        if(type === TYPE_UPDATE_LOCATION_PHONE) {
          this.alertScheduledTask = true;
        }
      })
    }
  },
  data: () => ({
    open: false,
    loading: false,
    formValid: true,
    formDataOriginal: {},
    formData: {
      schedule_type: TYPE_UPDATE_LOCATION_PHONE,
      primary_phone: '',
      schedule_start: '',
      schedule_start_at: '',
      schedule_end: '',
      schedule_end_at: ''
    },
    phoneRules: [
      (v) => (v && v.length <= 15 || v.length === 0) || 'Telefone precisa ter menos de 15 caracteres',
      (v) => (v && v.length >= 14 || v.length === 0) || 'Telefone precisa ter pelo menos de 14 caracteres'
    ],
    alertScheduledTask: null,
  }),
  beforeDestroy() {
    this.resetData()
  },
  watch: {
    location(location) {
      if (!this.bulkUpdate) {
        this.formData.primary_phone = get(location, 'data.primary_phone');
        this.formDataOriginal.primary_phone = get(
            location,
            'data.primary_phone'
        );
      }
    },
    open(open) {
      if (open && !this.bulkUpdate) {
        this.formData.primary_phone = get(this.location,'data.primary_phone')
        this.formDataOriginal.primary_phone = get(this.location,'data.primary_phone')
      }
    }
  }
};
</script>

<style scoped></style>
